var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFireFeaturesFireExclusionArea = function SvgFireFeaturesFireExclusionArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DF0000",
    d: "M2 2.097h20v20H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4.097h16v16H4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DF0000",
    fillRule: "evenodd",
    d: "M13.295 20.097h-2.829l-2.265-2.265 1.414-1.414zm6.705-.78v.78h-2.048l-5.508-5.508 1.414-1.414zm0-7.485v2.828l-3.314-3.313 1.415-1.415zm-.078-7.735H20v.078zm-10.485 0h2.828l3.806 3.806-1.414 1.414zM4 6.146V4.097h.78l7.049 7.049-1.415 1.414zm0 4.656 3.586 3.586-1.414 1.415L4 13.63z",
    clipRule: "evenodd"
  })));
};
export default SvgFireFeaturesFireExclusionArea;